import { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import { LuxAccordion, LuxTextInput, LuxRichInputText } from '@lux/wardrobe-lib'
import { ProjectsService } from '@/app/services/ProjectsService'
import SectionItem from '../Layout/SectionItem/SectionItem'
import './ForumInformation.scss'

export interface ForumInformationProps {
    title: string
    description: string
    onSetTitle: Dispatch<SetStateAction<string>>
    onSetDescription: Dispatch<SetStateAction<string>>
    titleInputLabel: string
}

const ForumInformation = ({
    title,
    description,
    onSetTitle,
    onSetDescription,
    titleInputLabel,
}: ForumInformationProps) => {
    const intl = useIntl()

    const accordionTitle = useMemo(
        () =>
            intl.formatMessage({
                id: 'modals.new.forum.information.title',
                defaultMessage: 'Information',
            }),
        [intl]
    )
    const placeholder = useMemo(
        () =>
            intl.formatMessage({
                id: 'modals.common.placeholder',
                defaultMessage: 'Type here...',
            }),
        [intl]
    )
    const descriptionLabel = useMemo(
        () =>
            intl.formatMessage({
                id: 'modals.new.forum.description',
                defaultMessage: 'Description',
            }),
        [intl]
    )

    return (
        <>
            <LuxAccordion title={accordionTitle}>
                <div className='smart-modals-forum-information-title'>
                    <SectionItem>
                        <LuxTextInput
                            value={title}
                            onChangeCallback={onSetTitle}
                            mandatory={true}
                            label={titleInputLabel}
                            placeholder={placeholder}
                            style={{ backgroundColor: 'var(--lux-white)' }}
                        />
                    </SectionItem>
                </div>
                <LuxRichInputText
                    value={description}
                    onChangeCallback={onSetDescription}
                    placeholder={placeholder}
                    label={descriptionLabel}
                    fileUploadUrl={ProjectsService.FROALA_UPLOAD_URL}
                />
            </LuxAccordion>
        </>
    )
}

export default ForumInformation
